/**
 * Register the Consultation
 */
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

export default function RegisterForConsultationForm() {
    const selectors = {
        'form' : '[data-form="register-for-consultation"]',
    };

    this.init = () => {
        let $form = jQuery(selectors.form);
        if (!$form.length) return;
        this.handleForm();
    };

    this.handleForm = async () => {
        let isSubmitting = false;

        jQuery(selectors.form).on('submit', async (e) => {
            e.preventDefault();
            if (isSubmitting) return;
            isSubmitting = true;

            let $this = jQuery(e.target);
            let $form = $this.closest('form');
            let phone = $this.find('[name="phone"]').val();
            $form.find('[type="submit"]').after(`<input type="hidden" name="frontend_url" value="${window.location.href}" />`);
            let formData = new FormData(e.target);
            $form.find('[type="submit"]').prop('disabled', false);
            if(!this.isVietnamesePhoneNumber(phone)) {
                Swal.fire({
                    icon: "error",
                    title: "Lỗi",
                    text: "Số điện thoại không chính xác."
                });
                $form.find('[type="submit"]').prop('disabled', false);

                isSubmitting = false;
                return false;
            }

            grecaptcha.ready(function() {
                grecaptcha.execute(theme_object.recaptcha, {action: 'submit'}).then(function(token) {
                    formData.append('recaptcha_token', token)
                    jQuery.ajax({
                        type : "POST",
                        dataType : "JSON",
                        url : theme_object.endpoint_url + 'register-consultation',
                        processData: false,
                        contentType: false,
                        data : formData,
                        context: this,
                        beforeSend: function(){
                            $form.find('.js-overlay').css({"display":"flex"});
                        },
                        success: function(response) {
                            if(response.status) {
                                Swal.fire({
                                    title: '<div className="text-primary">Thành công</div>',
                                    text: response.message
                                });
                                $this.trigger("reset");
                                $this.find('.js-select2').val('').trigger('change')
                            } else {
                                Swal.fire({
                                    title: '<div class="text-error">Lỗi</div>',
                                    text: response.message
                                });
                            }
                            setTimeout(()=> {
                                $form.find('[type="submit"]').prop('disabled', false);
                                $form.find('.js-overlay').css({"display":"none"});
                                isSubmitting = false;
                            }, 3000);
                        },
                        error: function(error){
                            Swal.fire({
                                title: '<div class="text-error">Lỗi</div>',
                                text: error.responseJSON.message
                            });
                            setTimeout(()=> {
                                $form.find('[type="submit"]').prop('disabled', false);
                                $form.find('.js-overlay').css({"display":"none"});
                                isSubmitting = false;
                            }, 3000);
                        }
                    })
                })
            })

            return false;
        })
    }

    this.isVietnamesePhoneNumber = (number) => {
        return /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/.test(number);
    }

}
